// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkTile--placeholder .jlbbg{background:#f4f7fa}", ""]);
// Exports
exports.locals = {
	"logo": "jlbbg"
};
module.exports = exports;
